import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

type CheckBoxProps = {
  label?: string
  value?: boolean
  name?: string
  disabled?: boolean
  readOnly?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
}

export const CheckBox = ({label, name, value, disabled, readOnly, onChange}: CheckBoxProps) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          checked={!!value}
          onChange={(e, checked) => onChange?.(e, checked)}
          disabled={disabled || readOnly}
          data-test-id={`checkbox-${name}`}
        />
      }
      label={label}
    />
  )
}
